import { Button } from '@mui/material'
import React from 'react'

const AimdMultiScreenBtn = ({onClick,btnText}) => {
 
    return <Button 
    
    
    sx={{
        maxWidth: '321px',  // Set maxWidth to 321px
        width: '100%',      // Full width within its container
        minWidth: '100%',   // Ensure the width doesn't shrink
        height: {
            xs: '40px',
            sm: '40px',
            md: '60px',
            lg: "65px"
        },
        // minHeight : "30px",
        padding: {
            xs: '8px 5px',
            sm: '12px 14px',
            md: '12px 14px',
            lg: "12px 12px"
        },
         border: "3px solid transparent !important",
        background: "linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%)",
        // padding: "10px 50px",
      
        // boxShadow: "0px 12px 30px 6px rgba(0, 0, 0, 0.05), 0px 18px 40px 10px rgba(0, 0, 0, 0.07)",
        // boxShadow: "0px 35px 35px 0px rgba(0, 0, 0, 0.09), 0px 9px 19px 0px rgba(0, 0, 0, 0.1)",
        boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.09),0px 5px 11px 0px rgba(0, 0, 0, 0.10)",
        borderRadius: "40px",
        color: "#fff",
        textAlign: "center",
        // fontSize: "20px",
        fontSize: {
            xs: '16px',
            lg: "20px"

        },
        fontWeight: 600,
        "&:hover": {
            color: "#69D6D8",
            background: "white",
            border: "3px solid #72d8da !important"
        }
    }
    }
        onClick={onClick}
    >
        {btnText ? btnText : "Next"}
    </Button>
  
}

export default AimdMultiScreenBtn